import { cr, interact } from "fire-wind-water";
import { DatePicker } from "./date";

class DateTime extends DatePicker {
  isShow = false;
  constructor(o) {
    super(o);
    this.isTime = true;
    this.resetModel = ["year", "month", "date", "hours", "minute", "second"];
  }

  resetRender(d) {
    if (interact.isMobile === 1) {
      this.resetWapRender(d);
    } else {
      this.setList();
      this.setVirtual();
      this.resetVirtual();
      this.addVirtual();
      this.render();
      this.resetScroll();
    }
  }

  selectThatDay(): void {
    this.model = new Date();
    this.updateValue();
    this.change({ model: this.model, value: this.value });
  }

  resetVirtual() {
    this.virtual[0].z[2] = {
      h: "div",
      c: "action-footer",
      z: [
        {
          h: "div",
          c: "action-item center",
          z: [
            {
              h: "span",
              c: "item-list",
              html: "此刻",
              event: () => {
                this.selectThatDay();
              },
            },
          ],
        },
        {
          h: "div",
          c: "action-item center",
          z: [
            {
              h: "span",
              c: "item-list",
              html: this.isShow ? "选择日期" : "选择时间",
              event: (ev) => {
                this.switchShowTime(ev);
              },
            },
          ],
        },
        {
          h: "div",
          c: "action-item center",
          z: [
            {
              h: "span",
              c: "item-list",
              html: "确定",
              event: () => {
                this.selectOk();
              },
            },
          ],
        },
      ],
    };
  }

  addVirtual() {
    const li = this.initTimes();
    const time = {
      h: "div",
      c: "time-picker",
      z: [
        {
          h: "div",
          c: "action-header",
          z: [
            {
              h: "div",
              c: "action-item-content",
              html: `${this.value.year}年 ${this.value.month}月 ${this.value.date}日`,
              event: (ev) => {
                ev.stopPropagation();
              },
            },
          ],
        },
        {
          h: "div",
          c: "action-mian flex",
          z: [
            {
              h: "ul",
              c: "time-list",
              id: "hfs-date-picker-hours",
              z: li.h,
            },
            {
              h: "ul",
              c: "time-list",
              id: "hfs-date-picker-minute",
              z: li.m,
            },
            {
              h: "ul",
              c: "time-list",
              id: "hfs-date-picker-second",
              z: li.s,
            },
          ],
        },
      ],
    };
    this.virtual.push(time);
  }

  initTimes() {
    const t = {
      h: [],
      m: [],
      s: [],
    };
    for (let i = 0; i <= 23; i++) {
      t.h.push({
        h: "li",
        c: this.value.hours === i ? "time-item active" : "time-item",
        html: i < 10 ? `0${i}` : i,
        event: (ev) => {
          this.selectHours(ev, i);
        },
      });
    }
    for (let i = 0; i <= 59; i++) {
      t.m.push({
        h: "li",
        c: this.value.minute === i ? "time-item active" : "time-item",
        html: i < 10 ? `0${i}` : i,
        event: (ev) => {
          this.selectMinute(ev, i);
        },
      });
      t.s.push({
        h: "li",
        c: this.value.second === i ? "time-item active" : "time-item",
        html: i < 10 ? `0${i}` : i,
        event: (ev) => {
          this.selectSecond(ev, i);
        },
      });
    }
    return t;
  }

  resetScroll() {
    const hours = document.getElementById("hfs-date-picker-hours");
    if (hours) {
      hours.scrollTop = this.value.hours * 24;
    }
    const minute = document.getElementById("hfs-date-picker-minute");
    if (minute) {
      minute.scrollTop = this.value.minute * 24;
    }
    const second = document.getElementById("hfs-date-picker-second");
    if (second) {
      second.scrollTop = this.value.second * 24;
    }
  }

  selectHours(ev, i) {
    ev.stopPropagation();
    this.value.hours = i;
    this.setClass("hours", i);
  }

  selectMinute(ev, i) {
    ev.stopPropagation();
    this.value.minute = i;
    this.setClass("minute", i);
  }

  selectSecond(ev, i) {
    ev.stopPropagation();
    this.value.second = i;
    this.setClass("second", i);
  }

  setClass(s, i) {
    const lis = document.getElementById("hfs-date-picker-" + s).children;
    cr.each(lis, (d, v) => {
      d.className = v === i ? "time-item active" : "time-item";
    });
  }

  switchShowTime(ev) {
    ev.stopPropagation();
    this.isShow = !this.isShow;
    ev.target.innerHTML = this.isShow ? "选择日期" : "选择时间";
    const dom: HTMLElement = document.querySelector(".time-picker");
    dom.style.display = this.isShow ? "block" : "none";
    this.resetScroll();
  }

  selectOk() {
    const o = this.value;
    this.model = new Date(
      `${o.year}/${o.month}/${o.date} ${o.hours}:${o.minute}:${o.second}`
    );
    this.change({ model: this.model, value: this.value });
  }
}

export { DateTime };
